export default function(store, { host }) {
  const Role = store.defineModel('role', {
    defaultValues: {
      description: '',
      memberIds: null,
      roleTagId: null,
    },

    afterAssignment(entity) {
      host.users._setMembersOnEntity(entity)
    },

    relations: {
      belongsTo: {
        assignmentGroup: { type: 'group', foreignKey: 'assignmentGroupId' },
        botUser: { type: 'user', foreignKey: 'botUserId' },
        escalationPolicy: { type: 'escalationPolicy', foreignKey: 'escalationPolicyId' },
        organization: { type: 'organization', foreignKey: 'organizationId' },
        roleTag: { type: 'roleTag', foreignKey: 'roleTagId' },
      },
    },
  })

  return Role
}
